import React, { useState, FormEvent } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import Header from "../../../layout/header/Header";
import "./newSet.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ActiveLink from "../../../layout/active-link/ActiveLink";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';

const NewSet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleNewSetSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const setNameAndDomain = {
      domain: (e.currentTarget.elements[0] as HTMLInputElement).value,
      setName: (e.currentTarget.elements[2] as HTMLInputElement).value
    }
    if (!setNameAndDomain.domain || !setNameAndDomain.setName) {
      toast.warning("Please enter domain and set name!");
    } else {
      navigate("/assessment/new-set/question", { state: { NewSetDetails: setNameAndDomain } });
    }
  };
console.log(location.state)
  const options: string[] = [];
  location.state?.assessData.filter((val: any) => options.push(val.domain));

  console.log(options)

  const TypeaheadDomain: React.FC = () => {
    const [selectedList, setSelectedList] = useState<string[]>([]);

    return (
      <Typeahead
        id="typeaheadId"
        onChange={(selected: any) => {
          setSelectedList(selected);
        }}
        options={Array.from(new Set(options))}
        placeholder="Select or create domain"
        selected={selectedList}
      />
    );
  }
  return (
    <div className="container">
      <Header />
      <div className="app-pageSize">
        <ActiveLink targetLink="New Set" />
        <div className="newSet__header">
          <p>Domain specified Questionnaire panel</p>
        </div>
        <div className="newSet__body">
          <form onSubmit={handleNewSetSubmit}>
            <div className="newSet__inputContainer d-inline-flex align-items-center">
              <div className="d-inline-flex align-items-center">
                <label>Domain:</label>
                <TypeaheadDomain />
              </div>
              <div className="d-inline-flex align-items-center">
                <label>SetName:</label>
                <input type="text" className="form-control" placeholder="Set Name" />
              </div>
              <div className="newSet__btn">
                <button>Enter</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewSet;
